import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=3a8cf9ab&scoped=true"
import script from "./placeholder.vue?vue&type=script&lang=js"
export * from "./placeholder.vue?vue&type=script&lang=js"
import style0 from "./placeholder.vue?vue&type=style&index=0&id=3a8cf9ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cf9ab",
  null
  
)

export default component.exports